import { Controller, useFormContext } from 'react-hook-form';
import { Typography } from '@components/Typography';
import { Switch } from '@components/Switch';
import { Input } from '@components/Input';
import { useTranslation } from '@hooks';
import { StyledTimeframePicker } from './styles';

const OfferSchedule = ({ isView }) => {
    const { control, watch, getValues, setValue, clearErrors } = useFormContext();
    const { t } = useTranslation();

    const offerEndEnabled = watch('offerEndEnabled');
    const redemptionPeriodEnabled = watch('redemptionPeriodEnabled');
    const waitPeriodEnabled = watch('waitPeriodEnabled');

    return (
        <div>
            <Typography variant="subtitle1" sx={{ color: 'var(--text-primary)', marginBottom: '8px' }}>
                {t('CouponsPage.offerSchedule')}
            </Typography>
            <div>
                <Controller
                    control={control}
                    name="offerEndEnabled"
                    render={({ field, ref }) => (
                        <Switch
                            {...field}
                            ref={ref}
                            checked={getValues('offerEndEnabled')}
                            handleChange={event => {
                                setValue('offerEndEnabled', event.target.checked, {
                                    shouldDirty: true,
                                    shouldValidate: true,
                                });
                                if (!event.target.checked) {
                                    setValue('offerEndDate', '', {
                                        shouldDirty: true,
                                        shouldValidate: true,
                                    });
                                    clearErrors('offerEndDate');
                                }
                            }}
                            label={t('CouponsPage.offerAndDate')}
                            disabled={isView}
                        />
                    )}
                />
                {offerEndEnabled ? (
                    <>
                        <Typography
                            variant="caption"
                            sx={{ color: 'var(--text-secondary)', display: 'block', marginBottom: '8px' }}
                        >
                            {t('CouponsPage.setFinalIssueDate')}
                        </Typography>
                        <Controller
                            control={control}
                            name="offerEndDate"
                            render={({ field, fieldState: { error } }) => (
                                <StyledTimeframePicker
                                    value={[field.value]}
                                    range={false}
                                    label={t('CouponsPage.offerAndDate')}
                                    onChangeTimeframe={value => {
                                        setValue('offerEndDate', value, {
                                            shouldDirty: true,
                                            shouldValidate: true,
                                        });
                                    }}
                                    onBlurTimeSelect={field.onBlur}
                                    minDate={new Date()}
                                    maxDate={null}
                                    required
                                    disabled={isView}
                                    error={error}
                                />
                            )}
                        />
                    </>
                ) : null}
            </div>
            <div>
                <Controller
                    control={control}
                    name="redemptionPeriodEnabled"
                    render={({ field, ref }) => (
                        <Switch
                            {...field}
                            ref={ref}
                            checked={getValues('redemptionPeriodEnabled')}
                            handleChange={event => {
                                setValue('redemptionPeriodEnabled', event.target.checked, {
                                    shouldDirty: true,
                                    shouldValidate: true,
                                });
                                if (!event.target.checked) {
                                    clearErrors('redemptionPeriodInDays');
                                    setValue('redemptionPeriodInDays', '', {
                                        shouldDirty: true,
                                        shouldValidate: true,
                                    });
                                }
                            }}
                            label={t('CouponsPage.redemptionPeriod')}
                            disabled={isView}
                        />
                    )}
                />
                {redemptionPeriodEnabled ? (
                    <>
                        <Typography
                            variant="caption"
                            sx={{ color: 'var(--text-secondary)', display: 'block', marginBottom: '8px' }}
                        >
                            {t('CouponsPage.periodOfValidity')}
                        </Typography>
                        <Controller
                            control={control}
                            name="redemptionPeriodInDays"
                            render={({ field, fieldState: { error }, ref }) => (
                                <Input
                                    ref={ref}
                                    inputProps={{ ...field, onChange: e => field.onChange(e.target.value) }}
                                    label={t('CouponsPage.redemptionPeriodDays')}
                                    fullWidth
                                    type="number"
                                    error={!!error}
                                    helperText={error ? t(error.message) : null}
                                    required
                                    disabled={isView}
                                    sx={{ width: 'calc(50% - 4px)' }}
                                />
                            )}
                        />
                    </>
                ) : null}
            </div>
            <div>
                <Controller
                    control={control}
                    name="waitPeriodEnabled"
                    render={({ field, ref }) => (
                        <Switch
                            {...field}
                            ref={ref}
                            checked={getValues('waitPeriodEnabled')}
                            handleChange={event => {
                                setValue('waitPeriodEnabled', event.target.checked, {
                                    shouldDirty: true,
                                    shouldValidate: true,
                                });
                                if (!event.target.checked) {
                                    clearErrors('waitPeriodInHours');
                                    setValue('waitPeriodInHours', '', {
                                        shouldDirty: true,
                                        shouldValidate: true,
                                    });
                                }
                            }}
                            label={t('CouponsPage.waitPeriod')}
                            disabled={isView}
                        />
                    )}
                />
                {waitPeriodEnabled ? (
                    <>
                        <Typography
                            variant="caption"
                            sx={{ color: 'var(--text-secondary)', display: 'block', marginBottom: '8px' }}
                        >
                            {t('CouponsPage.setDelay')}
                        </Typography>
                        <Controller
                            control={control}
                            name="waitPeriodInHours"
                            render={({ field, fieldState: { error }, ref }) => (
                                <Input
                                    ref={ref}
                                    inputProps={{ ...field, onChange: e => field.onChange(e.target.value) }}
                                    label={t('CouponsPage.waitPeriodHours')}
                                    fullWidth
                                    type="number"
                                    error={!!error}
                                    helperText={error ? t(error.message) : null}
                                    required
                                    disabled={isView}
                                    sx={{ width: 'calc(50% - 4px)' }}
                                />
                            )}
                        />
                    </>
                ) : null}
            </div>
        </div>
    );
};

export default OfferSchedule;
